import { render } from "./CreditNoteDocument.vue?vue&type=template&id=04ef886a"
import script from "./CreditNoteDocument.vue?vue&type=script&lang=js"
export * from "./CreditNoteDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__